module.exports = __webpack_public_path__ + "static/media/carrorama-elite.07789852.jp2";